import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const NAMES = ['Martín', 'Lucía', 'Franco', 'Valentina', 'Santiago', 'Camila', 'Mateo', 'Sofía'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta'];
const PRODUCTS = ['BLACK ✪ CLASSIC', 'DARK ✯ VIOLET', 'SILVER ✮ METAL'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    product: ''
  });
  useEffect(() => {
    // Initial delay - first popup after 10 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 10000);
    const showNotification = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
      setNotification({
        name,
        city,
        product
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      // Schedule next notification - random between 60-90 seconds + 5s display time
      const nextDelay = Math.random() * 30000 + 60000 + 5000; // 60-90 seconds + 5s
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-142">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-24 right-4 z-30 max-w-sm rounded-lg bg-white p-4 shadow-xl ring-1 ring-black/5 sm:right-6" data-id="element-143">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-144">
            <X className="h-4 w-4" data-id="element-145" />
          </button>

          <div className="flex items-start gap-4" data-id="element-146">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#FF6B35]/10 text-[#FF6B35]" data-id="element-147">
              <ShoppingBag className="h-5 w-5" data-id="element-148" />
            </div>
            <div data-id="element-149">
              <p className="text-sm font-medium text-gray-900" data-id="element-150">
                <span className="font-bold" data-id="element-151">{notification.name}</span> de{' '}
                {notification.city}
              </p>
              <p className="text-sm text-gray-600" data-id="element-152">
                acaba de comprar{' '}
                <span className="font-semibold text-[#FF6B35]" data-id="element-153">
                  {notification.product}
                </span>
              </p>
              <p className="mt-1 text-xs text-gray-400" data-id="element-154">Hace unos instantes</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}